$(document).ready(function () {
    var clocks = [];

    $(".postContent p u").mouseover(function (e) {
        var th = this;
        for (var i = 0; i < clocks.length; i++) {
            if (clocks[i].text == th.textContent) {
                clearTimeout(clocks[i].t);
            }
        }
        var rect = e.target.getBoundingClientRect();
        var offset = cumulativeOffset(e.target);
        var padding = 0;
        if (offset.left == rect.left) {
            padding = (rect.right - rect.left) + 10;

        }
        else {
            padding = (rect.right - offset.left) + 10;
        }
        var mainOffset = cumulativeOffset($('main>.grid-container')[0]);
        offset.left = offset.left - mainOffset.left;
        offset.top = offset.top - mainOffset.top;
        $(this).parent().prev().css('left', offset.left + padding).css('top', offset.top);
        $(this).parent().prev().show();
    });
    $(".postContent p u").mouseleave(function (e) {
        var th = this;
        var t = setTimeout(function () {
            $(th).parent().prev().hide();
        }, 1000);
        clocks.push({
            text: th.textContent,
            t: t
        });
    });
});

var cumulativeOffset = function (element) {
    var top = 0, left = 0;
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);

    return {
        top: top,
        left: left
    };
};